
document.addEventListener("DOMContentLoaded", () => {
  console.log("CEA Theme JS loaded");

  // ===== SÉLECTEURS DOM =====
  const mobileMenuToggle = document.querySelector(".mobile-menu-toggle");
  const mobileMenu = document.querySelector(".mobile-menu");
  const mobileMenuOverlay = document.querySelector(".mobile-menu-overlay");
  const mobileMenuClose = document.querySelector(".mobile-menu-close");
  const siteHeader = document.querySelector(".site-header");
  const body = document.body;

  // ===== MENU MOBILE =====

  /**
   * Ouvrir le menu mobile
   */
  function openMobileMenu() {
    mobileMenu?.classList.add("open");
    mobileMenuOverlay?.classList.add("open");
    mobileMenuToggle?.classList.add("active");
    body.style.overflow = "hidden";
  }

  /**
   * Fermer le menu mobile
   */
  function closeMobileMenu() {
    mobileMenu?.classList.remove("open");
    mobileMenuOverlay?.classList.remove("open");
    mobileMenuToggle?.classList.remove("active");
    body.style.overflow = "";
  }

  /**
   * Toggle menu mobile au clic sur le bouton burger
   */
  mobileMenuToggle?.addEventListener("click", (e) => {
    e.preventDefault();

    if (mobileMenu?.classList.contains("open")) {
      closeMobileMenu();
    } else {
      openMobileMenu();
    }
  });

  /**
   * Fermer le menu via l'overlay
   */
  mobileMenuOverlay?.addEventListener("click", closeMobileMenu);

  /**
   * Fermer le menu via le bouton close
   */
  mobileMenuClose?.addEventListener("click", closeMobileMenu);

  /**
   * Fermer le menu au redimensionnement si on passe en desktop
   */
  window.addEventListener("resize", () => {
    if (window.innerWidth >= 768 && mobileMenu?.classList.contains("open")) {
      closeMobileMenu();
    }
  });

  // ===== HEADER STICKY AVEC SHADOW AU SCROLL =====

  let lastScrollTop = 0;

  window.addEventListener("scroll", () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    // Ajouter la classe "scrolled" si scroll > 50px
    if (scrollTop > 50) {
      siteHeader?.classList.add("scrolled");
    } else {
      siteHeader?.classList.remove("scrolled");
    }

    lastScrollTop = scrollTop;
  });

  // ===== SMOOTH SCROLL POUR LES ANCRES =====

  /**
   * Smooth scroll vers les ancres internes (#section)
   */
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", (e) => {
      const targetId = anchor.getAttribute("href");

      // Ignorer les liens vides ou juste "#"
      if (!targetId || targetId === "#") {
        return;
      }

      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        e.preventDefault();

        // Calculer la position avec offset pour le header sticky
        const offsetTop = targetElement.offsetTop - 100;

        // Smooth scroll natif
        window.scrollTo({
          top: offsetTop,
          behavior: "smooth",
        });

        // Focus sur l'élément pour l'accessibilité
        targetElement.setAttribute("tabindex", "-1");
        targetElement.focus();
      }
    });
  });

  // ===== ACCESSIBILITÉ : ESC POUR FERMER LE MENU =====

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && mobileMenu?.classList.contains("open")) {
      closeMobileMenu();
    }
  });

  // ===== TRAP FOCUS DANS LE MENU MOBILE =====

  mobileMenu?.addEventListener("keydown", (e) => {
    if (e.key === "Tab") {
      const focusableElements = mobileMenu.querySelectorAll(
        'a, button, input, [tabindex]:not([tabindex="-1"])'
      );

      if (focusableElements.length === 0) return;

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      // Tab + Shift : retour au dernier élément
      if (e.shiftKey && document.activeElement === firstElement) {
        e.preventDefault();
        lastElement.focus();
      }
      // Tab seul : retour au premier élément
      else if (!e.shiftKey && document.activeElement === lastElement) {
        e.preventDefault();
        firstElement.focus();
      }
    }
  });

  // ===== ANIMATION SVG PICTO : APPARITION PATH PAR PATH DEPUIS LE CENTRE =====

  function revealPictoSvg(svg) {
    const paths = Array.from(svg.querySelectorAll("path"));
    if (!paths.length) return;

    const viewBox = svg.viewBox.baseVal;
    const centerX = viewBox.width / 2;
    const centerY = viewBox.height / 2;

    // Calculer la taille et la distance de chaque path
    paths.forEach((path) => {
      const bbox = path.getBBox();
      path._area = bbox.width * bbox.height;
      const px = bbox.x + bbox.width / 2;
      const py = bbox.y + bbox.height / 2;
      path._dist = Math.sqrt((px - centerX) ** 2 + (py - centerY) ** 2);
    });

    // Trier : plus petit d'abord, puis par distance du centre à taille égale
    paths.sort((a, b) => a._area - b._area || a._dist - b._dist);

    const totalDuration = 2000;

    // Fade-in progressif : du plus petit path au plus gros
    // Courbe ease-in pour étaler les gros paths sur la fin
    paths.forEach((path, i) => {
      const progress = i / (paths.length - 1);
      const delay = Math.pow(progress, 1.6) * totalDuration;
      setTimeout(() => (path.style.opacity = "1"), delay);
    });
  }

  // Observer pour déclencher au scroll
  const pictoObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          revealPictoSvg(entry.target);
          pictoObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.3 }
  );

  document.querySelectorAll(".group-picto svg").forEach((svg) => {
    pictoObserver.observe(svg);
  });
  // ===== HERO NAV STICKY : AFFICHAGE DU LOGO =====

  const heroNav = document.querySelector('.hero-nav');
  const heroHeader = document.querySelector('.hero-slider');

  if (heroNav && heroHeader) {
    const stickyObserver = new IntersectionObserver(
      ([entry]) => {
        heroNav.classList.toggle('is-sticky', !entry.isIntersecting);
      },
      { threshold: 0 }
    );
    stickyObserver.observe(heroHeader);
  }

  // ===== NAV ACTIONS : ALIGNEMENT AU DESSUS DU SOMMAIRE =====

  function alignNavActionsToSommaire() {
    const actions = document.querySelector('.hero-nav__actions');
    if (!actions) return;

    const heading = document.querySelector('.sommaire__heading') || document.querySelector('main h1') || document.querySelector('h1');
    const navInner = document.querySelector('.hero-nav__inner');

    if (window.innerWidth < 782 || !heading || !navInner) {
      actions.style.left = '';
      actions.style.transform = '';
      return;
    }

    const headingLeft = heading.getBoundingClientRect().left;
    const navLeft    = navInner.getBoundingClientRect().left;

    actions.style.left      = `${headingLeft - navLeft}px`;
    actions.style.transform = 'none';
  }

  alignNavActionsToSommaire();
  // Montrer les actions une fois positionnées
  const actionsEl = document.querySelector('.hero-nav__actions');
  if (actionsEl) actionsEl.classList.add('is-positioned');
  window.addEventListener('resize', alignNavActionsToSommaire);

  // ===== SOMMAIRE FOOTER : ALIGNEMENT SUR COLONNE TEXTE =====

  function alignSommaireFooter() {
    const footer = document.querySelector('.sommaire-footer');
    const primaryCols = document.querySelector('.page-content-layout__columns');
    if (!footer || !primaryCols) return;

    const textCol = primaryCols.querySelectorAll(':scope > .wp-block-column')[1];
    if (!textCol || window.innerWidth < 1024) {
      footer.style.paddingLeft = '';
      return;
    }

    footer.style.paddingLeft = textCol.getBoundingClientRect().left + 'px';
  }

  alignSommaireFooter();
  window.addEventListener('resize', alignSommaireFooter);

  // ===== HERO SLIDER AUTO-FADE =====

  const heroSlider = document.querySelector(".hero-slider");

  if (heroSlider) {
    const slides = heroSlider.querySelectorAll(".hero-slider__slide");
    const slideCount = slides.length;

    if (slideCount > 1) {
      let currentIndex = 0;
      const INTERVAL_MS = 5000;
      const prefersReducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      );

      function nextSlide() {
        slides[currentIndex].classList.remove("is-active");
        slides[currentIndex].setAttribute("aria-hidden", "true");

        currentIndex = (currentIndex + 1) % slideCount;

        slides[currentIndex].classList.add("is-active");
        slides[currentIndex].setAttribute("aria-hidden", "false");
      }

      let intervalId = null;

      function startAutoRotation() {
        if (intervalId) return;
        intervalId = setInterval(nextSlide, INTERVAL_MS);
      }

      function stopAutoRotation() {
        if (intervalId) {
          clearInterval(intervalId);
          intervalId = null;
        }
      }

      if (!prefersReducedMotion.matches) {
        startAutoRotation();
      }

      prefersReducedMotion.addEventListener("change", (e) => {
        if (e.matches) {
          stopAutoRotation();
        } else {
          startAutoRotation();
        }
      });

      document.addEventListener("visibilitychange", () => {
        if (document.hidden) {
          stopAutoRotation();
        } else if (!prefersReducedMotion.matches) {
          startAutoRotation();
        }
      });
    }
  }
});
